import { __assign, __rest } from "tslib";
import * as React from 'react';
import { PanelContent } from '../../Panel';
import { classNames } from '../../utils/stringUtils';
import styles from '../Modal.module.css';
export var ModalContent = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children, htmlAttributes = __rest(_a, ["className", "children"]);
    var modalContentClassNames = classNames((_b = {},
        _b[styles.mdsCompModalContent] = true,
        _b[className] = true,
        _b));
    return (React.createElement(PanelContent, __assign({ className: modalContentClassNames }, htmlAttributes), children));
};
//# sourceMappingURL=ModalContent.js.map